import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  > a {
    display: flex;
    text-decoration: none;
    color: black;
    justify-content: center;
    align-items: center;
  }

  .bar {
    margin: 13px 0px;
    width: 0px;
    height: 45px;
    border-right: 1px solid ${(props) => props.theme.colors.grey2};
  }

  .triangle {
    padding-top: 14px;
    padding-left: 4px;
  }

  .active-global {
    filter: saturate(1) brightness(1);
  }
`
export const GlobalDropDown = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  padding-left: 1.4rem;
  padding-right: 1.1rem;
  img {
    width: 27px;
  }
  filter: saturate(0) brightness(0.3);
  transition: filter 300ms ease-in;

  &:hover {
    filter: saturate(1) brightness(1);
  }
  @media only screen and (max-width: 580px) {
    padding: 0 1rem 0 1.4rem;
  }
`

export const LogoWrapper = styled.div`
  margin-left: 0.8rem;

  > svg {
    width: 56px;
    height: 56px;
    @media only screen and (max-width: 500px) {
      height: 50px;
      width: 50px;
    }
    fill: ${({ theme }) => theme.colors.logo};
  }
`
export const LogoTextWrapper = styled.div`
  padding: 0.8rem 0px 0.8rem 1.2rem;
  > h1 {
    transition: 300ms ease-in color;
    font-size: 27px;
    font-weight: 600;
    padding-bottom: 2px;
  }

  > p {
    transition: 300ms ease-in color;
    font-size: 19px;
    font-weight: 300;
  }
  transition: 300ms ease-in color;
  &:hover {
    > h1,
    p {
      color: ${({ theme }) => theme.colors.active1};
    }
  }

  @media only screen and (max-width: 580px) {
    padding: 0;
    max-width: 150px;
    padding-left: 1.2rem;
    > h1 {
      font-size: 20px;
    }
    > p {
      font-size: 15px;
    }
  }
`
